
const getDistinctAttributeValues = (array, column) => {
    return [...new Set(array.map(item => item[column]))]
}

const getDistinctValues = (array) => {
    return [...new Set(array)]
}
// input an array of strings and return an array of dropdown option objects 
const toOptionsList = (array) => {
    return array.toSorted().map((item, i) => ({ key: i, value: item, label: item }))
}

const addDerivedCols = (data) => {
    const cols = data.length > 0 ? Object.keys(data[0]) : []
    if (cols.includes('MST') && cols.includes('WT')) {
        data.forEach(record => {
            if (!record.YLDBUA) {
                record.YLDBUA = ''
            }
            if (record.WT && record.MST) {
                const WT = parseFloat(record.WT)
                const MST = parseFloat(record.MST);
                if (WT === -9.00 || MST == -9.00) {
                    record.YLDBUA = '-9.00';
                }
                else {
                    if (record.YEAR < 2023) {
                        const ROW_LEN = 14.00;
                        const YLDBUA = ((WT * 320.166) / ROW_LEN) * (1 - (MST / 100)) * 1.13
                        record.YLDBUA = YLDBUA.toFixed(2).toString();
                    }
                    else if (record.YEAR >= 2023 && record.YEAR <= 2024) {
                        const ROW_LEN = 14.93;
                        const YLDBUA = (WT / 60) * (((100 - MST) * 0.01) / 0.87) * (43560 / (ROW_LEN * 5));
                        record.YLDBUA = YLDBUA.toFixed(2).toString();
                    }
                    else if (record.YEAR > 2024) {
                        const ROW_LEN = 17.50
                        const YLDBUA = (WT / 60) * (((100 - MST) * 0.01) / 0.87) * (43560 / (ROW_LEN * 5));
                        record.YLDBUA = YLDBUA.toFixed(2).toString();
                    }
                }
            }
        })
    }

}


// Function to pivot data so that each value of TRAIT becomes its own column populated by data in the DATA column.
// data must be sorted/grouped by all non TRAIT/DATA columns, and must be sorted by TRAIT within those groups.
// should work for both means and raw data
const pivotData = (data) => {
    const traits = getDistinctAttributeValues(data, 'TRAIT');
    const columns = data[0] === undefined ? [] : Object.keys(data[0]).filter(col => col !== 'DATA'); // TRAIT column will be placeholder for pivoted columns
    const output = [];
    let pivotedRecord;
    let duplicateList = [];
    let listPointer = 0;
    data.forEach(dataPoint => {
        if (pivotedRecord !== undefined &&
            columns.every(col => col === 'TRAIT' || pivotedRecord[col] === dataPoint[col])
        ) {
            if (pivotedRecord[dataPoint.TRAIT] === null) {
                pivotedRecord[dataPoint.TRAIT] = dataPoint.DATA;
                listPointer = 0;
            }
            else { // if a group has multiple dataPoints for the same TRAIT, create a new pivoted record where all non TRAIT/DATA cols match
                if (duplicateList[listPointer] === undefined) {
                    duplicateList[listPointer] = {};
                    columns.forEach(col => {
                        if (col !== 'TRAIT')
                            duplicateList[listPointer][col] = dataPoint[col];
                        else
                            traits.forEach(trait => { duplicateList[listPointer][trait] = null; });
                    });
                }
                duplicateList[listPointer][dataPoint.TRAIT] = dataPoint.DATA;
                listPointer++;
            }
        }
        else {
            if (pivotedRecord !== undefined) {
                output.push(pivotedRecord);
                duplicateList.forEach(record => {
                    output.push(record)
                });
            }

            pivotedRecord = {};
            columns.forEach(col => {
                if (col !== 'TRAIT')
                    pivotedRecord[col] = dataPoint[col];
                else
                    traits.forEach(trait => { pivotedRecord[trait] = null });
            });
            pivotedRecord[dataPoint.TRAIT] = dataPoint.DATA;

            duplicateList = [];
            listPointer = 0;
        }
    })

    if (pivotedRecord !== undefined) {
        output.push(pivotedRecord);
        duplicateList.forEach(record => {
            output.push(record)
        });
    }
    return output;
}

export {
    toOptionsList, pivotData, getDistinctAttributeValues, getDistinctValues, addDerivedCols
}